<template>

    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/orderInfo' }">订单管理</el-breadcrumb-item>
                    <el-breadcrumb-item>已统筹订单</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="orderCreateRecord" class="demo-form-inline" label-width="120px" size="mini" @submit.native.prevent>
                    <el-form-item label="统筹日期">
                        <el-input v-model="orderCreateRecord.condition.createDate" placeholder="统筹日期" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="" >
                        <el-button type="info" @click="queryOrderCreateRecord" @keyup.enter.native="enterQuery" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table
                    :data="orderCreateRecords"
                    style="width: 100%"
                    v-if="tableHeight"
                    :height="tableHeight"
                    size="mini"
                    border
                    v-loading="loading"
                    empty-text="暂无数据"
                    :row-style="rowStyle">
                    <el-table-column fixed type="index" label="序号" width="50"></el-table-column>
                    <el-table-column prop="createDate" label="统筹日期" width="200"></el-table-column>
                    <el-table-column prop="createNo" label="统筹序号" width="200"></el-table-column>
                    <el-table-column prop="statusDesc" label="状态" show-overflow-tooltip width="150"></el-table-column>
                    <el-table-column prop="overallCount" label="统筹订单数量" width="200"></el-table-column>
                    <el-table-column prop="createByName" label="统筹人" width="200"></el-table-column>
                    <el-table-column prop="createTime" label="统筹时间"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="160">
                        <template slot-scope="scope">
                            <span style="margin-left:5px;">
                                <el-button @click="view(scope.row)" type="text" size="small">查看</el-button>
                            </span>
                            <span style="margin-left:5px;">
                                <el-button @click="del(scope.row)" type="text" size="small">删除</el-button>
                            </span>
                            <span style="margin-left:5px;">
                                <el-button @click="exportExcel(scope.row)" type="text" size="small">导出</el-button>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

        <!--  -->
        <el-drawer
            :title="title"
            :visible.sync="drawer"
            :direction="direction"
            :before-close="handleClose"
            size="80%">
            <el-row  type="flex" justify="end">
                <el-button type="primary" @click="doExportExcel" size="mini" style="margin-right: 10px; margin-bottom: 10px;">导出</el-button>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-table
                        :data="orderInfos"
                        style="width: 100%"
                        size="mini"
                        :height="tableHeight + 150"
                        border
                        v-loading="orderLoading"
                        empty-text="暂无数据">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="experimentNum" fixed label="实验编号" width="200"></el-table-column>
                        <el-table-column prop="orderCode" label="订单编号" width="200"></el-table-column>
                        <el-table-column prop="customerName" label="客户姓名" width="150"></el-table-column>
                        <el-table-column prop="carrierName" label="载体名称" show-overflow-tooltip width="200"></el-table-column>
                        <el-table-column prop="detectionPrimer" label="检测引物" show-overflow-tooltip width="200"></el-table-column>asdfsdsfasd
                        <el-table-column prop="resistance" label="抗性" show-overflow-tooltip width="100"></el-table-column>
                        <el-table-column prop="bacterialStrain" label="菌株" show-overflow-tooltip width="100"></el-table-column>
                        <el-table-column prop="sampleNum" label="样品编号" width="200"></el-table-column>
                        <el-table-column prop="address" label="收货地址" show-overflow-tooltip width="200"></el-table-column>
                        <el-table-column prop="insertFragment" label="插入片段" width="200"></el-table-column>
                        <el-table-column prop="isPurifyingDesc" label="是否已经纯化" width="200"></el-table-column>
                        <el-table-column prop="upstreamSite" label="上游位点" show-overflow-tooltip width="200"></el-table-column>
                        <el-table-column prop="downstreamSite" label="下游位点" show-overflow-tooltip width="200"></el-table-column>
                        <el-table-column prop="isSequencingDesc" label="是否测序" width="200"></el-table-column>
                        <el-table-column prop="sequenceCompany" label="送测公司" width="200"></el-table-column>
                        <el-table-column prop="positiveCloneNum" label="阳性克隆数" width="200"></el-table-column>
                        <el-table-column prop="sequencePrimerName" label="测序引物名称" show-overflow-tooltip width="200"></el-table-column>
                        <el-table-column prop="email" label="测序邮箱" show-overflow-tooltip width="200"></el-table-column>
                        <el-table-column prop="insertFragmentSeq" label="插入片段序列" show-overflow-tooltip width="200"></el-table-column>
                        <el-table-column prop="orderStatusDesc" label="订单状态" width="100"></el-table-column>
                        <el-table-column prop="companySg" label="生工" width="100"></el-table-column>
                        <el-table-column prop="companyKtr" label="昆泰锐" width="100"></el-table-column>
                        <el-table-column prop="companyQk" label="擎科" width="100"></el-table-column>
                        <el-table-column prop="companyHc" label="合测" width="100"></el-table-column>
                        <el-table-column prop="companyJkr" label="奥科" width="100"></el-table-column>
                        <el-table-column prop="resultFileName" label="测序结果" show-overflow-tooltip width="200">
                            <template slot-scope="scope">
                                <el-link type="primary" @click="dowloadFile(scope.row)">{{ scope.row.resultFileName  }}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderAmount" label="订单金额" width="200"></el-table-column>
                        <el-table-column prop="payWillingnessDesc" label="支付意愿确认" width="200"></el-table-column>
                        <el-table-column prop="customSettlementAmount" label="客户结算金额" width="200"></el-table-column>
                        <el-table-column prop="agentSettlementAmount" label="代理结算金额" width="200"></el-table-column>
                        <el-table-column prop="userLevel" label="客户等级" width="100"></el-table-column>
                        <el-table-column prop="customBalance" label="客户余额" width="100"></el-table-column>
                        <el-table-column prop="agentBalance" label="代理余额" width="100"></el-table-column>
                        <el-table-column prop="attrCustomerName" label="归属责任客户" width="200"></el-table-column>
                        <el-table-column prop="agentName" label="代理/收送样员" show-overflow-tooltip width="200"></el-table-column>
                        
                    </el-table>
                </el-col>
            </el-row>
        </el-drawer> 
    </div>
    
</template>

<script>

export default {
    name:'OverallOrder',
    components: {
    },
    data() {
        return {
            orderCreateRecord:{
                condition:{
                },
                pageNum: 1,
                pageSize:20
            },
            drawer: false,
            direction: 'rtl',
            orderInfos: [],
            currentPage: 1,
            pageSize:20,
            total:10,
            timer:'',
            orderInfoProp:{},
            title:"新增订单",
            dataStatuses:[],
            isReceipts: [],
            dialogFormVisible: false,
            formLabelWidth:"120px",
            titleView: "查看订单",
            drawerView: false,
            isUpdate: true,
            isView: true,
            isHasAuthority: false,
            isShowCustomerName: false,
            isShowSampleNum: false,
            isShowExperimentNum: false,
            isShowIsSequencing: false,
            isShowPayWillingness: false,
            isShowAttributableCustomer: false,
            isShowRegionalAgency: false,
            isShowOverallPlan: false,
            labelStyle:{"text-align":"right"},
            totalOrderAmount: "",
            totalCommissionAmount:"",
            isDirector: false,
            isAdmin: false,
            isHasDel: false,
            confirmationReviews: [],
            isShowQuotationAmount: false,
            directors:[],
            commissioners:[],
            tableHeight: "",//表格高度
            confirmationReviewDisabled: false,
            isReceiptDisabled: false,
            isCommissionDisabled: false,
            isCommissions: [],
            orderStatuses:[],
            statusDisabled: true,
            loading: false,
            orderLoading: false,
            props: { multiple: true, checkStrictly: true},
            yesOrNo: [],
            payWillingnesses: [],
            orderCreateRecords:[],
            currentOrderCreateRecord: {},
        }
    },
    methods: {
        update(row) {
            this.title = "修改订单";
            this.drawer = true;
            this.orderInfoProp = row;
            this.timer = new Date().getTime();
            this.isUpdate = true;
            this.isView = false;
        },
        view(row) {
            this.title = "统筹订单列表";
            this.drawer = true;
            this.currentOrderCreateRecord = row;
            this.timer = new Date().getTime();
            this.isUpdate = false;
            this.isView = true;
            this.queryOrders();
        },
        handleSizeChange(val) {
            this.currentPage = 1;
            this.pageSize = val;
            this.queryOrderCreateRecord();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.queryOrderCreateRecord();
        },
        handleClose(done) {
            if(!this.isView) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryOrderCreateRecord();
                })
                .catch(() => {});
            } else {
                done();
            }
        },
        handleCloseView(done) {
            this.$confirm('确认关闭？')
            .then(()=> {
                done();
                this.queryOrderCreateRecord();
            })
            .catch(() => {});
        },
        queryOrderCreateRecord() {
            this.loading = true;
            this.$axios.post("/orderCreateRecord/findList",this.orderCreateRecord).then(
                res=>{
                    if(res.data.status === "success"){
                        this.orderCreateRecords = res.data.result.list;
                        this.total = res.data.result.total;
                    } else {
                        this.$message.error(res.data.message);
                    }
                    this.loading = false;
                },
                error=>{
                    this.$message.error(error.message);
                    this.loading = false;
                }
            )
        },
        closeDrawer() {
            this.drawer = false;
            this.queryOrderCreateRecord();
        },
        rowStyle({ row }) {
            if(row.dataColor === 'GREEN') {
                let styleJson = {
                    "background-color": "lightgreen"
                }
                return styleJson;
            } else if(row.dataColor === 'RED') {
                let styleJson = {
                    "background-color" : "#F08080"
                }
                return styleJson;
            } else if(row.dataColor === 'YELLOW') {
                let styleJson = {
                    "background-color": "lightyellow"
                }
                return styleJson;
            } else if(row.dataColor === 'GRAY') {
                let styleJson = {
                    "background-color": "lightgray"
                }
                return styleJson;
            } else if(row.dataColor === 'BLUE') {
                let styleJson = {
                    "background-color": "lightblue"
                }
                return styleJson;
            } else if(row.dataColor === 'PURPLE') {
                let styleJson = {
                    "background-color": "#E8B1FF"
                }
                return styleJson;
            } else if(row.dataColor === 'ORANGE') {
                let styleJson = {
                    "background-color": "#FFA500"
                }
                return styleJson;
            }
            
        },
        queryOrders() {
            this.orderLoading = true;
            let param = {
                id: this.currentOrderCreateRecord.id
            }
            this.$axios.post("/order/queryHasOveralledOrder",param).then(
                res=>{
                    if(res.data.status === "success"){
                        this.orderInfos = res.data.result;
                    } else {
                        this.$message.error(res.data.message);
                    }
                    this.orderLoading = false;
                },
                error=>{
                    this.$message.error(error.message);
                    this.orderLoading = false;
                }
            )
        },
        exportExcel(row) {
            if(row) {
                this.currentOrderCreateRecord = row;
            }
            this.doExportExcel();
        },
        doExportExcel() {
            let param = {
                id: this.currentOrderCreateRecord.id
            }
            this.$axios.post("/order/exportOveralledExcel",param,
            {
                responseType:"blob"//注意 需要规定后台返回文件流格式
            }).then(
                res=>{
                    if (res) {
                        let fileNames = res.headers['content-disposition'] //获取到Content-Disposition;filename
                        let regFileNames = fileNames.match(/=(.*)$/)[1];
                        const link = document.createElement("a");
                        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });  //文件流处理
                        link.style.display = "none";  //去除a标签的样式
                        link.href = URL.createObjectURL(blob);
                        link.download = decodeURIComponent(regFileNames);
                        document.body.appendChild(link);
                        //模拟点击事件
                        link.click();
                        this.$message.success('导出成功');
                        this.loading = false;
                    }
                },
                error=>{
                    this.$message.error(error.message);
                    this.loading = false;
                }
            )
        },
        getTableHeight() {
            let tableH = 300; //距离页面下方的高度
            let tableHeightDetil = window.innerHeight - tableH;
            if (tableHeightDetil <= 300) {
                this.tableHeight = 300;
            } else {
                this.tableHeight = window.innerHeight - tableH;
            }
        },
        enterQuery(){
            document.onkeydown =(e) => {
                e = window.event || e;
                if(this.$route.path=='/home/hasOveralledOrder'&&(e.code=='Enter'||e.code=='enter')){
                    //调用查询方法
                    this.queryOrderCreateRecord();
                    return;
                }
            }
        },
        del(row) {
            this.$confirm('您确认删除该记录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.$axios.post("/orderCreateRecord/delete",row).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.queryOrderCreateRecord();
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        }
    },
    mounted() {
        let _this = this;
        window.onresize = () => {
        if (_this.resizeFlag) {
            clearTimeout(_this.resizeFlag);
        }
        _this.resizeFlag = setTimeout(() => {
            _this.getTableHeight();
            _this.resizeFlag = null;
        }, 100);
        };

    },
    created() {
        this.getTableHeight();
        this.queryOrderCreateRecord();
        this.enterQuery();
    }
    
}


</script>

<style scoped>

   .el-form {
       margin-top: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }
   .el-select {
        width: 220px;
    }

    .el-input {
        width: 220px;
    }
    .el-date-picker {
        width: 200px;
        background-color: green;
    }
    .el-cascader {
        width: 220px;
    }
    .margin-top {
        margin-top: 10px;
    }
    /* ::v-deep .el-table tbody tr:hover>td { 
        background-color: transparent !important;
    }
    ::v-deep .el-table__fixed-right tbody tr:hover>td {
        background-color: transparent !important;
    } */

    ::v-deep  .el-table .el-table__body tr.hover-row > td{
        background-color: #FFC0CB !important
    }

    ::v-deep  .el-tablle--enable-row-hover .el-table__body tr:hover > td{
        background-color:#FFC0CB !important
    }

    .emptyBg {
        display:block;
    }

</style>
